import React, { useEffect, useState } from "react";
import { Modal_Frame } from "../components/Modal_Frame";
import model_mining_logo_2 from "../assets/model_mining_logo_2.jpg";
import mm_logo from "../assets/mm_logo.png";
import nvar_button from "../assets/barra_sidebar.png";
import chat_button from "../assets/chat_icon.svg";
import power_icon from "../assets/power_icon.png";
import { useLocation, useNavigate } from "react-router-dom";
import { checkAuthLogin } from "../services/checkAuthApi";
import { GpsGate_Frame } from "../components/GpsGate_Frame";
import Select from "react-select";
import { joinApplication } from "../services/initializeApplication";
import { IframeBlockerOverlay } from "../components/IframeBlockerOverlay";
import LoadEditor from "../features/LoadEditor/components/LoadEditor";
import EquipmentsHealthTable from "../features/EquipmentHealth/components/EquipmentsHealthTable";
import FieldNotificationWindow from "../features/FieldNotifications/components/FieldNotificationWindow";
import { logout } from "../services/logout";

export const Main_ApplicationTestF = () => {
  const [isContainerModalsOpen, setIsContainerModalsOpen] = useState(false);
  const [applicationList, setApplicationList] = useState([]);
  const [selectedApp, setSelectedApp] = useState(null);
  const [isOpenSidebar, setIsOpenSidebar] = useState(false);
  const [isRefreshGpsFrame, setIsRefreshGpsFrame] = useState(true);
  const [sidebarTittle, setSidebarTittle] = useState("");
  const [userName, setUserName] = useState("");
  const [userId, setUserId] = useState("");
  const [tokenAccessApi, setTokenAccessApi] = useState("");
  const [isAuthPage, setIsAuthPage] = useState(false);
  const [allMainMenu, setAllMainMenu] = useState([]);
  const [allSubMenu, setAllSubMenu] = useState([]);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const [sesionUserId, setSesionUserId] = useState("");

  const componentsSystem = {
    LoadEditor, EquipmentsHealthTable, FieldNotificationWindow
  }

  const navigate = useNavigate();
  const location = useLocation();

  //console.log(location.state);

  useEffect(() => {
    let timer;
    if (isTransitioning) {
      timer = setTimeout(() => {
        setIsTransitioning(false);
      }, 300); // Coincide con la duración de la transición de tu sidebar
    }
    return () => clearTimeout(timer);
  }, [isTransitioning]);

  const handleGPS = () => {
    const form = document.createElement("form");
    const url1 = "http://213.255.227.209/comGpsGate/public/login";
    const url2 = "https://simplefms.io/comGpsGate/public/login";
    form.action = url1;
    form.method = "POST";
    form.target = "_blank"; // Abrir en nueva pestaña

    // Inputs ocultos
    const userInput = document.createElement("input");
    userInput.type = "hidden";
    userInput.name = "username";
    userInput.value = "jorge.parada";

    const passInput = document.createElement("input");
    passInput.type = "hidden";
    passInput.name = "password";
    passInput.value = "Huachipato.3831";

    // Agregar inputs al formulario
    form.appendChild(userInput);
    form.appendChild(passInput);

    // Agregar el formulario al DOM, enviarlo y luego removerlo
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  };
  const logout_action = async () => {
    console.log('Se va a cerrar sesion ', sesionUserId);
    const result = await logout(sesionUserId);
  };
  const toggleSidebar = () => {
    setIsTransitioning(true);
    setIsOpenSidebar(!isOpenSidebar);
  };
  const toggleSubmenu = (id_menu) => {
    //console.log(id_menu);
    setAllMainMenu((prevMenus) =>
      prevMenus.map(
        (menu) =>
          menu.id_menu === id_menu
            ? { ...menu, is_show: !menu.is_show } // Cambia el valor de is_show
            : menu // Deja el resto de los menús sin cambios
      )
    );
  };
  const openModulesMenu = (id_sub_menu) => {
    //console.log(id_sub_menu);
    setAllSubMenu((prevSubMenu) =>
      prevSubMenu.map((subMenu) =>
        subMenu.id_sub_menu == id_sub_menu
          ? { ...subMenu, is_show: !subMenu.is_show }
          : subMenu
      )
    );
    setIsContainerModalsOpen(true);
    //console.log(allSubMenu);
  };
  //Tengo que validar que todos esten cerrados.
  const closeModulesMenu = (id_sub_menu) => {
    console.log("Se cierra modal");
    //console.log(id_sub_menu);
    setAllSubMenu((prevSubMenu) =>
      prevSubMenu.map((subMenu) =>
        subMenu.id_sub_menu == id_sub_menu
          ? { ...subMenu, is_show: !subMenu.is_show }
          : subMenu
      )
    );
    //console.log(allSubMenu);
  };
  const minimizeModulesMenu = (id_sub_menu) => {
    console.log("Se minimiza modal");
    //console.log(id_sub_menu);
    setAllSubMenu((prevSubMenu) =>
      prevSubMenu.map((subMenu) =>
        subMenu.id_sub_menu == id_sub_menu
          ? { ...subMenu, is_minimize: !subMenu.is_minimize }
          : subMenu
      )
    );
    //console.log(allSubMenu);
  };
  const focusModals = (id_sub_menu) => {
    console.log("Se prioriza modal");
    //console.log(id_sub_menu);
    setAllSubMenu((prevSubMenu) =>
      prevSubMenu.map((subMenu) =>
        subMenu.id_sub_menu == id_sub_menu
          ? { ...subMenu, zindex: 102 }
          : { ...subMenu, zindex: 101 }
      )
    );
    //console.log(allSubMenu);
  };

  const handleChangeApplication = async (selectedApp) => {
    setSelectedApp(selectedApp);
    //console.log(selectedApp);
    setIsRefreshGpsFrame(false);
    await joinApplication(userId, selectedApp, applicationList, navigate);
    setIsRefreshGpsFrame(true);
  };

  return (
    <div>
        <div className="h-screen flex border-4">
          {/* NAV - 5% de altura */}
          <nav className="fixed top-0 left-0 right-0 h-20 w-full bg-gray-100 flex items-center justify-start border-4  z-40 pointer-events-auto">
            <div
              className={`flex space-x-4 items-center transition-all duration-100 ${
                isOpenSidebar ? "ml-72" : "ml-3"
              }`}
            >
              <img
                className="h-8 w-auto hover:bg-gray-200 rounded-md"
                src={nvar_button}
                alt="Model Mining"
                onClick={toggleSidebar}
              />
              <div className="w-80">
                <Select
                  className="ml-12 z-40"
                  value={selectedApp}
                  onChange={handleChangeApplication}
                  options={applicationList}
                />
              </div>
            </div>
            <div></div>
          </nav>
          <div
            className={`top-0 left-0 bg-gray-100 shadow-lg z-50 transition-all duration-100 ease-in-out flex-shrink-0 flex flex-col
            ${
              isOpenSidebar
                ? "w-72"
                : "w-0 overflow-hidden border-4"
            }`}
          >
            {isOpenSidebar && (
              <div className=" text-xl font-medium text-black p-5 flex flex-col items-center bg-gray-200 border-4 ">
                <img
                  className="h-14 w-auto hover:bg-gray-200 rounded-md cursor-pointer"
                  src={model_mining_logo_2}
                  alt="Model Mining"
                  onClick={toggleSidebar}
                />
                <div className="flex justify-between items-center w-full mt-4">
                  <p>{userName}</p>
                  <img
                    className="h-7 w-auto hover:bg-gray-200 rounded-md cursor-pointer"
                    src={power_icon}
                    alt="Model Mining"
                    onClick={logout_action}
                  />
                </div>
              </div>
            )}
            <div className="flex-1 overflow-y-auto p-4 bg-gray-100 border-4 ">
              <ul className="p-4 space-y-2 bg-gray-100">
                {allMainMenu.map((menu) => (
                  <li>
                    <button
                      className="block p-2 rounded hover:bg-gray-400 w-full text-left"
                      onClick={() => toggleSubmenu(menu.id_menu)}
                    >
                      {menu.name}
                    </button>
                    {menu.is_show && (
                      <ul className="ml-4 mt-1 space-y-1 text-sm text-gray-700">
                        {allSubMenu.map(
                          (subMenu) =>
                            menu.id_menu == subMenu.id_menu && (
                              <li>
                                <button
                                  className="block p-2 rounded hover:bg-gray-300 w-full text-left"
                                  onClick={() =>
                                    openModulesMenu(subMenu.id_sub_menu)
                                  }
                                >
                                  {subMenu.name}
                                </button>
                              </li>
                            )
                        )}
                      </ul>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="flex-grow flex flex-col bg-white transition-all duration-300 ease-in-out h-screen border-4 ">
            {/* CONTAINER 1 (90% de la altura disponible del content-area) */}

            <div className="relative w-full flex flex-col h-screen">
              {isTransitioning && <IframeBlockerOverlay />}
              {/* CONTENEDOR PRINCIPAL - 95% de altura */}
              <div className="h-full flex flex-col overflow-auto ">
                {/* CONTENIDO PRINCIPAL */}
                <div className=" flex-grow p-4 w-full">
                  {isRefreshGpsFrame && <GpsGate_Frame className=" z-3" />}
                  {allSubMenu.map(
                    (subMenu) =>
                      subMenu.is_show && (
                        <Modal_Frame
                          key={subMenu.id_sub_menu}
                          id={subMenu.id_sub_menu}
                          onFocusModal={focusModals}
                          isOpen={subMenu.is_show}
                          onClose={closeModulesMenu}
                          title={subMenu.name}
                          size="2xl"
                          zIndex={subMenu.zindex}
                          isMinimize={subMenu.is_minimize}
                          minimizeFunction={minimizeModulesMenu}
                          url_frame={subMenu.url_frame}
                          sidebar_info={{active: isOpenSidebar, width:72}}
                          SelectedAppID={selectedApp}
                          isComponent={subMenu.is_component}
                          componentName={componentsSystem[subMenu.component_name] ?? null}
                          userId={userId}
                        />
                      )
                  )}
                </div>
              </div>
              {/* CONTAINER 2 (10% de la altura disponible del content-area) */}
             
            </div>
          </div>
           {isContainerModalsOpen && (
                <div className={`fixed bottom-0 left-0 right-0 h-10 bg-gray-100 flex items-center justify-start border-4 
                   ${
                isOpenSidebar ? "ml-72" : "ml-3"
              }`}>
                  {allSubMenu.map(
                    (subMenu) =>
                      subMenu.is_show && (
                        <div>
                          <button
                            className="text-white border-solid ml-1 mt-1 px-1 bg-gray-700"
                            onClick={() =>
                              minimizeModulesMenu(subMenu.id_sub_menu)
                            }
                          >
                            {subMenu.name}
                          </button>
                        </div>
                      )
                  )}
                </div>
              )}
        </div>
      
    </div>
  );
};
